<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

onMounted(() => {
  try {
    const accessToken = localStorage.getItem('accessToken')
    const userId = localStorage.getItem('userId')

    if (accessToken !== null) {
      store.commit('Global/user/setAccessToken', accessToken)
    }

    if (accessToken !== null) {
      store.commit('Global/user/setUserId', userId)
    } else {
      store.commit('Global/user/setUserId', crypto.randomUUID())
    }
  } catch (error) {
    store.commit('Global/user/setUserId', crypto.randomUUID())
  }
})
</script>

<style lang="scss" src="./styles/themes.scss" />
